import { api } from 'common';

import { SubFlowFormFields } from './FormFields';
import { getSubFlowBlockDefaultConfig } from './constants';
import { subFlowDocumentationMarkdown } from './documentation';
import { ProducedType } from '../../../../types';
import { type BlockConfigProps } from '../../../types';
import { SubFlowNodeOutputContent } from '../OutputContent';

export const subFlowV2Config: BlockConfigProps<api.FlowDefinition.SubFlowV2BlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'subFlowBlock',
  defaultConfig: getSubFlowBlockDefaultConfig(),
  returnType: ProducedType.SubFlowV1Result,
  configFields: {
    schema: api.FlowDefinition.SubFlowV2BlockConfigSchema,
    FormFields: SubFlowFormFields,
  },
  documentationMarkdown: subFlowDocumentationMarkdown,
  OutputContentComponent: SubFlowNodeOutputContent,
};
